// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { MergeTemplate } from './merge-template';
import { ReportLayout } from './report-layout';
import { ReportReportCategory } from './report-report-category';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Report extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  reportId!: number;
  baseReportId?: number;
  createdBy!: string;
  createdDate!: Date;
  datasourceSubType?: number;
  datasourceType?: number;
  description!: string;
  locationId!: number;
  mergeTemplateId?: number;
  precedentActionDescription?: string;
  precedentActionId?: number;
  reportLayoutId?: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  mergeTemplate!: MergeTemplate;
  reportLayout!: ReportLayout;
  reportReportCategories!: ReportReportCategory[];
}

